export default __webpack_public_path__ + "static/media/banner_bline.eb4bb401.svg";